import { compose } from "redux";

import withSecondaryBarSet from "app/pages/sales-intelligence/hoc/withSecondaryBarSet";
import EnrichmentLogsContainer from "app/pages/sales-intelligence/modules/crm-enrichment/containers/EnrichmentLogsContainer/EnrichmentLogsContainer";
import withCrmEnrichmentProvider from "app/pages/sales-intelligence/pages/manage-integration/hocs/withCrmEnrichmentProvider";

const EnrichmentLogsPageContainer = compose(
    withCrmEnrichmentProvider,
    withSecondaryBarSet("SalesIntelligenceManagement"),
)(EnrichmentLogsContainer);

export default EnrichmentLogsPageContainer;
